import { render, staticRenderFns } from "./KnSupplierCategories.vue?vue&type=template&id=2c1af958&"
import script from "./KnSupplierCategories.vue?vue&type=script&lang=js&"
export * from "./KnSupplierCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports